import { UnitOfMeasureEnum } from "../../../shared/components/formulario/select/SelectUnitOfMeasure";
import { ModalityEnum, SectorEnum, TypeBondEnum } from "../../../shared/utils/enum/enum";


export interface CriarFuncionarioContract {
    corporateName: string | null,
    fantasyName: string | null,
    dateOfBirth: Date,
    admissionDate: Date | null,
    fullName: string | null,
    email: string,
    cnpj: string | null,
    cpf: string | null,
    phone: string,
    active: boolean,
    accountBank: {
        bank: string,
        agency: string,
        account: string,
        accountType: string,
        pixKey: string | null,
    },
    address: {
        zipCode: string,
        street: string,
        number: string,
        neighborhood: string,
        city: string,
        state: string,
        complement: string,
    },
    isResponsible: boolean,
    idWork: string | null,
    positionId: string | null,
    modality: UnitOfMeasureEnum,
    typeBond: TypeBondEnum,
    sector: string,
    salary: number | null,
    description: string | null,
}


export const setores: Record<string, string> = {
  rh: "RH",
  administrative: "Administrativo",
  "in-charge": "Encarregado"
};
